import {
  useQuery as tanstackUseQuery,
  useMutation as tanstackUseMutation,
  useQueryClient as tanstackUseQueryClient,
  QueryClientProvider,
  QueryClient,
  type UseQueryOptions,
  type UseMutationOptions,
  type UseQueryResult,
  type UseMutationResult,
} from '@tanstack/react-query';

export const useQuery = <TData>(
  options: UseQueryOptions<TData>,
): UseQueryResult<TData> => tanstackUseQuery<TData>(options);

export const useMutation = <TData, TError = Error, TVariables = void>(
  options: UseMutationOptions<TData, TError, TVariables>,
): UseMutationResult<TData, TError, TVariables> =>
  tanstackUseMutation<TData, TError, TVariables>(options);

export const useQueryClient = (): QueryClient => tanstackUseQueryClient();

// QueryClientProvider und QueryClient sind kein Hook/Funktion — kein sinnvoller Wrapper möglich
export { QueryClientProvider, QueryClient };
export type { UseQueryResult, UseMutationResult };
